
import Services from "./Components/Services";

import "./Homepage.css";
import CategoryHeader from "./Components/Category-header/CategoryHeader";
import { useEffect } from "react";

import "./Homepage.css";
import { useDispatch, useSelector } from "react-redux";
import { allServices, setAllservices } from "../../Redux/Slices/Pages/services/servicesSlice";
import SelectionHeader from "./Components/SelectionHeader/SelectionHeader";

const HomePage = () => {
  const dispatch =useDispatch();

 


  return (
    <div className=" w-full mx-auto mt-5">
      <SelectionHeader/>

      <div className="  mx-5">
        {/* <CategoryHeader /> */}

        <Services />
      </div>
    </div>
  );
};

export default HomePage;
